import { render, staticRenderFns } from "./ApplicationUpdates.vue?vue&type=template&id=5570cf6f&scoped=true"
import script from "./ApplicationUpdates.vue?vue&type=script&lang=js"
export * from "./ApplicationUpdates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5570cf6f",
  null
  
)

export default component.exports